import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

import { Observable } from 'rxjs';

import { RxComposite } from '../../model/rx-composite';
import { select, Store } from '@ngrx/store';
import { UserStoreSelector, UserStoreState } from '@nrwl/rx-state-user';
import { rxRequiredValidator } from '@nrwl/rx-validators';
import { isMomentDateValid, RxDatepickerModule } from '@nrwl/rx-datepicker';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RxButtonModule } from '@nrwl/rx-button';
import { RxSelectModule } from '@nrwl/rx-ui';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RxInputModule } from '@nrwl/rx-input';
import { RxIconModule } from '@nrwl/rx-icon';

export const enum STEPS {
  UPLOAD_PDF,
  FORM_SETTING,
}

@Component({
  selector: 'rx-upload-pdf-form',
  templateUrl: './rx-upload-pdf-form.component.html',
  styleUrls: ['./rx-upload-pdf-form.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    RxButtonModule,
    RxSelectModule,
    MatDatepickerModule,
    RxInputModule,
    RxDatepickerModule,
    RxIconModule,
  ],
})
export class RxUploadPdfFormComponent extends RxComposite implements OnInit, OnDestroy {
  public step = STEPS.UPLOAD_PDF;

  public uploadFormGroup: FormGroup;

  public settingFormGroup: FormGroup;

  public isBusy = false;

  public formAssembled = false;

  public templateData = null;

  public datetimeFormat: string;

  private _payload_2;
  @Input()
  public override set payload(value) {
    this._payload_2 = value;
  }
  public override get payload() {
    return this._payload_2;
  }

  public get formDate() {
    return this.settingFormGroup.value.date;
  }

  public get fileName() {
    return this.uploadFormGroup.value.formFileName;
  }

  public userDateFormat$: Observable<boolean>;

  constructor(
    private _formBuilder: FormBuilder,
    public sanitizer: DomSanitizer,
    private _userStore: Store<UserStoreState.UserState>,
  ) {
    super();
    this.userDateFormat$ = this._userStore.pipe(select(UserStoreSelector.getUserDateFormat));
  }

  ngOnInit() {
    this.uploadFormGroup = this._formBuilder.group({
      formFileName: [null, Validators.required],
      formFile: [null],
    });
    const setting = this.payload.fields[1].value;
    this.settingFormGroup = this._formBuilder.group({
      title: [null, rxRequiredValidator],
      date: [new Date(), [rxRequiredValidator, isMomentDateValid]],
      status: [setting ? setting.status : null, Validators.required],
    });

    this.userDateFormat$.subscribe((isEuDatetimeFormat: boolean) => {
      this.datetimeFormat = isEuDatetimeFormat ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
    });
  }

  ngOnDestroy() {}

  public selectFile(event: Event): void {
    const files: FileList | any = (<HTMLInputElement>event.target).files;

    if (files && files.length > 0) {
      this.uploadFormGroup.patchValue({
        formFileName: files[0].name,
        formFile: files[0],
      });
      this.settingFormGroup.patchValue({
        title: files[0].name.replace('.pdf', ''),
      });
    }
  }

  public onCancelClicked() {
    this.dialog.close();
  }

  public onNextStep() {
    this.step++;
  }

  public onCreateClicked() {
    const formFile = this.uploadFormGroup.value.formFile;
    const formName = formFile ? formFile.name : '';

    this.payload.fields[0].value.file = formFile;
    this.payload.fields[0].value.fileName = formName;

    this.payload.fields[1].value = this.settingFormGroup.value;
    this.dialog.submitClicked();
  }

  public override isValid() {
    return true;
  }
}
